var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('SloLoader',{attrs:{"loading":_vm.loading,"size":"xl"}},[_c('ReturnDetails',{attrs:{"returnRequest":_vm.returnRequest}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }